import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { adsListViews } from 'Core/constants'
import { Item as VehiclePartItem } from 'SRC/modules/vehicleParts/list/components'
import { Item } from '../ItemNew'
import { Banner } from '../Banner'
import { Preloader } from 'SRC/ui/Preloader'

export const List = React.forwardRef((props, ref) => {
  const { ads, style, noAdsMessage, isLoading, isMobileDevice } = props

  return (
    <div
      className={`${ads.length ? 'ads-list-grid-view' : 'oglasi-content-list_no-ads'}`}
      style={{ display: style === adsListViews.TABLE ? 'grid' : 'none' }}
      ref={ref}
    >
      {ads.length && style === adsListViews.TABLE ? ads.map(item => {
        if (item.banner) return <Banner key={item.key} slotId={item.slotId} />
        if (item.isVehiclePart) return <VehiclePartItem item={item} isLoading={isLoading} key={item.productCode} isPromoted />
        if (item.isVehiclePart) return null
        return <Item ad={item} isLoading={isLoading} key={item.id} />
      }) : isLoading
        ? <Preloader /> : (
          <div className='oglasi-content-text__no-ads-text'>
            {noAdsMessage}
          </div>
        )
      }
    </div>
  )
})

List.displayName = 'GridView'

List.propTypes = {
  ads: PropTypes.arrayOf(PropTypes.object).isRequired,
  style: PropTypes.oneOf([
    adsListViews.LIST,
    adsListViews.TABLE
  ]),
  noAdsMessage: PropTypes.string,
  isLoading: PropTypes.bool,
  isMobileDevice: PropTypes.bool,
}

List.defaultProps = {
  ads: []
}
